// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowRight = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowRight = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowRight = _exports.ArrowRight = function ArrowRight(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.8782 10.2017C16.8512 10.267 16.8123 10.3258 16.7633 10.3748L11.796 15.342C11.6924 15.4456 11.5562 15.498 11.4199 15.498C11.2837 15.498 11.1474 15.4463 11.0438 15.342C10.8359 15.134 10.8359 14.797 11.0438 14.589L15.1027 10.5302H3.61424C3.32046 10.5302 3.08203 10.2917 3.08203 9.99797C3.08203 9.70419 3.32046 9.46577 3.61424 9.46577H15.1021L11.0431 5.40689C10.8352 5.19898 10.8352 4.86189 11.0431 4.65398C11.251 4.44607 11.5881 4.44607 11.796 4.65398L16.7633 9.62117C16.8123 9.67013 16.8512 9.72895 16.8782 9.79424C16.9321 9.9248 16.9321 10.0711 16.8782 10.2017Z",
      fill: "#212B36"
    }));
  };
});
